export default "__VITE_ASSET__0TERLD3k__"